export interface TextSegment {
  type: 'text' | 'bold' | 'italic' | 'code' | 'codeblock' | 'link'
  content: string
  href?: string
}

const PATTERNS: [RegExp, (match: RegExpMatchArray) => TextSegment][] = [
  [/```([\s\S]+?)```/, (m) => ({ type: 'codeblock', content: m[1]! })],
  [/`([^`]+)`/, (m) => ({ type: 'code', content: m[1]! })],
  [/\*\*(.+?)\*\*/, (m) => ({ type: 'bold', content: m[1]! })],
  // Underscore emphasis only at word boundaries (CommonMark: no intraword `_`),
  // so identifiers like my_name_is and snake_case don't turn italic.
  [/(?<!\w)__(.+?)__(?!\w)/, (m) => ({ type: 'bold', content: m[1]! })],
  [/\*(.+?)\*/, (m) => ({ type: 'italic', content: m[1]! })],
  [/(?<!\w)_(.+?)_(?!\w)/, (m) => ({ type: 'italic', content: m[1]! })],
  [/(https?:\/\/[^\s<>"')\]]+)/, (m) => ({ type: 'link', content: m[1]!, href: m[1]! })],
]

export function parseMessageText(text: string): TextSegment[] {
  const segments: TextSegment[] = []
  let remaining = text

  while (remaining.length > 0) {
    let earliest: { index: number; length: number; segment: TextSegment } | null = null

    for (const [pattern, handler] of PATTERNS) {
      const match = remaining.match(pattern)
      if (match && match.index !== undefined) {
        if (!earliest || match.index < earliest.index) {
          earliest = { index: match.index, length: match[0].length, segment: handler(match) }
        }
      }
    }

    if (!earliest) {
      segments.push({ type: 'text', content: remaining })
      break
    }

    if (earliest.index > 0) {
      segments.push({ type: 'text', content: remaining.slice(0, earliest.index) })
    }
    segments.push(earliest.segment)
    remaining = remaining.slice(earliest.index + earliest.length)
  }

  return segments
}
